import { c as _c } from "react/compiler-runtime";
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Dialog } from '@onefootprint/ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Form from './form';
import useCopyPlaybook from './hooks/use-copy-playbook';
import useTenantsOptions from './hooks/use-tenants-options';
export type CopyHandler = {
  launch: () => void;
};
export type CopyProps = {
  playbook: PlaybookVersionNoGraph;
};
type FormData = {
  name: string;
  tenantId: string;
  tenantName: string;
};
const Copy = forwardRef<CopyHandler, CopyProps>((t0, ref) => {
  const $ = _c(29);
  const {
    playbook
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "copy"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbooks", t1);
  const copyPlaybookMutation = useCopyPlaybook();
  const tenantsQuery = useTenantsOptions();
  const [open, setOpen] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => ({
      launch: () => setOpen(true)
    });
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useImperativeHandle(ref, t3, t4);
  let t5;
  if ($[4] !== copyPlaybookMutation || $[5] !== playbook.id) {
    t5 = formData => {
      copyPlaybookMutation.mutate({
        name: formData.name,
        playbookId: playbook.id,
        tenantId: formData.tenantId,
        tenantName: formData.tenantName
      }, {
        onSuccess: () => {
          handleClose();
        }
      });
    };
    $[4] = copyPlaybookMutation;
    $[5] = playbook.id;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleSubmit = t5;
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== copyPlaybookMutation.isPending || $[10] !== t6) {
    t7 = {
      label: t6,
      type: "submit",
      form: "copy-playbook-form",
      loading: copyPlaybookMutation.isPending
    };
    $[9] = copyPlaybookMutation.isPending;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp2);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== copyPlaybookMutation.isPending || $[15] !== t8) {
    t9 = {
      label: t8,
      onClick: handleClose,
      disabled: copyPlaybookMutation.isPending
    };
    $[14] = copyPlaybookMutation.isPending;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t(_temp3);
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== handleSubmit || $[20] !== playbook || $[21] !== tenantsQuery.data) {
    t11 = tenantsQuery.data && <Form onSubmit={handleSubmit} playbook={playbook} tenants={tenantsQuery.data} />;
    $[19] = handleSubmit;
    $[20] = playbook;
    $[21] = tenantsQuery.data;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== open || $[24] !== t10 || $[25] !== t11 || $[26] !== t7 || $[27] !== t9) {
    t12 = <Dialog onClose={handleClose} open={open} primaryButton={t7} secondaryButton={t9} size="compact" title={t10}>{t11}</Dialog>;
    $[23] = open;
    $[24] = t10;
    $[25] = t11;
    $[26] = t7;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
});
export default Copy;
function _temp($) {
  return $.form.cta;
}
function _temp2($_0) {
  return $_0.form.cancel;
}
function _temp3($_1) {
  return $_1.title;
}